import { getDaysElapsed } from "./datetime";

/**
 * Prefix used to identify external challenges.
 * NOTE: This must match EXTERNAL_CHALLENGE_PREFIX in
 * src/main/kotlin/com/duolingo/languagechallenge/model/Challenge.kt
 */
export const EXTERNAL_CHALLENGE_PREFIX = "EXT-";

export const isMegaChallenge = (challengeId: string) =>
  challengeId.endsWith("-MEGA");

export const isExternalChallenge = (challengeId: string) =>
  challengeId.startsWith(EXTERNAL_CHALLENGE_PREFIX);

export const getEstimateXpPerDay = (
  dueDayTimestampMs: number,
  remainingXp: number,
) => {
  const currentTimestampMs = new Date().getTime();
  // If the due day has already passed, just return the remaining Xp
  if (currentTimestampMs > dueDayTimestampMs) {
    return remainingXp;
  }
  // Use ceil here for the edge case when users have less than 1 day left
  const remainingDays = getDaysElapsed(
    currentTimestampMs,
    dueDayTimestampMs,
    "ceil",
  );
  return Math.ceil(remainingXp / remainingDays);
};
